<p-tabMenu
  [model]="measurementTabs"
  [activeItem]="measurementTabsActive"
  styleClass="flex justify-content-center"
  #measurementsTabMenu
>
  <ng-template pTemplate="item" let-item let-i="index">
    <i [class]="item.icon"></i>{{item.label | transloco}}
    <div *ngIf="item.id == 'deviceMeasurements'" class="ml-1"> ({{ currentDeviceMeasurements.length }})</div>
    <div *ngIf="item.id == 'assetMeasurements'" class="ml-1"> ({{ currentAssetMeasurements.length }})</div>
    <div *ngIf="item.id == 'kpis'" class="ml-1"> ({{ currentKpis.length }})</div>
  </ng-template>
</p-tabMenu>

<div class="flex flex-column mb-3">
  <div class="mt-2" *ngIf="currentDeviceMeasurements && measurementsTabMenu.activeItem.id === 'deviceMeasurements'">
    <app-device-measurements-selector
      [(visible)]="displayDeviceMeasurementSelector"
      [(selection)]="currentDeviceMeasurements"
      [tenant]="synopticInfoForm.get('tenant').value"
      [organization]="synopticInfoForm.get('organization').value"
      (selectionChange)="deviceMeasurementsChange.emit($event)"
      selectionMode="multiple"
    ></app-device-measurements-selector>
    <div class="flex justify-content-center pt-2 pb-3">
      <button
        [disabled]="!synopticInfoForm.get('tenant').value"
        (click)="displayDeviceMeasurementSelector = true"
        [label]="'select.deviceSensors' | transloco"
        pButton
        pRipple
      ></button>
    </div>
    <div class="p-datatable p-component">
      <p-table
        [(first)]="deviceMeasurementsFirst"
        [(rows)]="deviceMeasurementsRows"
        [value]="currentDeviceMeasurements"
        [totalRecords]="currentDeviceMeasurements.length"
        [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
        [paginator]="true"
        styleClass="p-datatable-striped"
        sortField="name"
        #deviceMeasurementsTable
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="w-18rem" pSortableColumn="device.serialNumber">
              {{'model.device' | transloco}}
              <p-sortIcon field="device.serialNumber"></p-sortIcon>
            </th>
            <th class="w-18rem" pSortableColumn="name">
              {{'model.sensor' | transloco}}
              <p-sortIcon field="name"></p-sortIcon>
            </th>
            <th pSortableColumn="description">
              {{'attribute.description' | transloco}}
              <p-sortIcon field="description"></p-sortIcon>
            </th>
            <th pSortableColumn="measurementType.sensor">
              {{'model.sensorType' | transloco}}
              <p-sortIcon field="measurementType.sensor"></p-sortIcon>
            </th>
            <th class="w-4rem"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-measurement>
          <tr>
            <td>
              <span class="p-column-title bold">{{'model.device' | transloco}}</span>
              {{measurement.device.serialNumber}}
            </td>
            <td>
              <span class="p-column-title bold">{{'model.sensor' | transloco}}</span>
              <p class="text-right md:text-left" style="word-break: break-all;">{{measurement.name}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
              {{measurement.description}}
            </td>
            <td>
              <span class="p-column-title bold">{{'model.sensorType' | transloco}}</span>
              {{measurement.measurementType?.sensor ?? ''}}
            </td>
            <td class="p-0">
              <span class="p-column-title bold">{{'common.actions' | transloco}}</span>
              <div class="flex justify-content-end">
                <button
                  (click)="removeDeviceMeasurement(measurement); deviceMeasurementsTable._filter()"
                  class="p-button-rounded btn-danger-light mr-2"
                  pButton
                  pRipple
                  icon="pi pi-trash"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="mt-2" *ngIf="currentAssetMeasurements && measurementsTabMenu.activeItem.id === 'assetMeasurements'">
    <app-asset-measurements-selector
      [(visible)]="displayAssetMeasurementSelector"
      [(selection)]="currentAssetMeasurements"
      [tenant]="synopticInfoForm.get('tenant').value"
      [organization]="synopticInfoForm.get('organization').value"
      (selectionChange)="assetMeasurementsChange.emit($event)"
      selectionMode="multiple"
    ></app-asset-measurements-selector>
    <div class="flex justify-content-center pt-2 pb-3">
      <button
        [disabled]="!synopticInfoForm.get('tenant').value"
        (click)="displayAssetMeasurementSelector = true"
        [label]="'select.assetSensors' | transloco"
        pButton
        pRipple
      ></button>
    </div>
    <div class="p-datatable p-component">
      <p-table
        [(first)]="assetMeasurementsFirst"
        [(rows)]="assetMeasurementsRows"
        [value]="currentAssetMeasurements"
        [totalRecords]="currentAssetMeasurements.length"
        [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
        [paginator]="true"
        styleClass="p-datatable-striped"
        sortField="name"
        #assetMeasurementsTable
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="w-18rem" pSortableColumn="asset.alias">
              {{'model.asset' | transloco}}
              <p-sortIcon field="asset.alias"></p-sortIcon>
            </th>
            <th class="w-18rem" pSortableColumn="name">
              {{'model.sensor' | transloco}}
              <p-sortIcon field="name"></p-sortIcon>
            </th>
            <th pSortableColumn="description">
              {{'attribute.description' | transloco}}
              <p-sortIcon field="description"></p-sortIcon>
            </th>
            <th pSortableColumn="measurementType.sensor">
              {{'model.sensorType' | transloco}}
              <p-sortIcon field="measurementType.sensor"></p-sortIcon>
            </th>
            <th class="w-4rem"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-measurement>
          <tr>
            <td>
              <span class="p-column-title bold">{{'model.asset' | transloco}}</span>
              {{measurement.asset.alias}}
            </td>
            <td>
              <span class="p-column-title bold">{{'model.sensor' | transloco}}</span>
              <p class="text-right md:text-left" style="word-break: break-all;">{{measurement.name}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
              {{measurement.description}}
            </td>
            <td>
              <span class="p-column-title bold">{{'model.sensorType' | transloco}}</span>
              {{measurement.measurementType?.sensor ?? ''}}
            </td>
            <td class="p-0">
              <span class="p-column-title bold">{{'common.actions' | transloco}}</span>
              <div class="flex justify-content-end">
                <button
                  (click)="removeAssetMeasurement(measurement); assetMeasurementsTable._filter()"
                  class="p-button-rounded btn-danger-light mr-2"
                  pButton
                  pRipple
                  icon="pi pi-trash"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="mt-2" *ngIf="currentKpis && measurementsTabMenu.activeItem.id === 'kpis'">
    <app-kpis-selector
      [(visible)]="displayKpisSelector"
      [kpis]="currentKpis"
      [actionButtons]="selectKpisActions"
      [tenant]="synopticInfoForm.get('tenant').value"
      [organization]="synopticInfoForm.get('organization').value"
    ></app-kpis-selector>
    <div class="flex justify-content-center pt-2 pb-3">
      <button
        [disabled]="!synopticInfoForm.get('tenant').value"
        (click)="displayKpisSelector = true"
        [label]="'select.kpis' | transloco"
        pButton
        pRipple
      ></button>
    </div>
    <div class="p-datatable p-component">
      <p-table
        [(first)]="kpisFirst"
        [(rows)]="kpisRows"
        [value]="currentKpis"
        [totalRecords]="currentKpis.length"
        [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
        [paginator]="true"
        styleClass="p-datatable-striped"
        sortField="name"
        #kpisTable
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="name">
              {{'attribute.name' | transloco}}
              <p-sortIcon field="name"></p-sortIcon>
            </th>
            <th pSortableColumn="description">
              {{'attribute.description' | transloco}}
              <p-sortIcon field="description"></p-sortIcon>
            </th>
            <th pSortableColumn="organization.name" *ngIf="'ROLE_ADMIN' | userHasRole: false">
              {{'model.organization' | transloco}}
              <p-sortIcon field="organization.name"></p-sortIcon>
            </th>
            <th class="w-4rem"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-kpiRow>
          <tr>
            <td>
              <span class="p-column-title bold">{{'attribute.alias' | transloco}}</span>
              <p class="text-right md:text-left">{{kpiRow.name}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
              <p class="text-right md:text-left">{{kpiRow.description}}</p>
            </td>
            <td *ngIf="'ROLE_ADMIN' | userHasRole: false">
              <span class="p-column-title bold">{{'model.organization' | transloco}}</span>
              <p class="text-right md:text-left">{{kpiRow.organization?.name}}</p>
            </td>
            <td class="p-0">
              <span class="p-column-title bold">{{'common.actions' | transloco}}</span>
              <div class="flex justify-content-end">
                <button
                  (click)="removeKpi(kpiRow); kpisTable._filter()"
                  class="p-button-rounded btn-danger-light mr-2"
                  pButton
                  pRipple
                  icon="pi pi-trash"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

